import { useTranslation } from 'react-i18next';
import { AppToggleButton } from '@/UI/AppToggleButtons/AppToggleButton';
import { toggleButtonClasses } from '@/UI/AppToggleButtons';
import { AspectRatioIcon } from '@/UI/Icons/AspectRatioIcon';
import { AspectRatioOnIcon } from '@/UI/Icons/AspectRatioOnIcon';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

interface LockAspectRatioButtonProps {
  isLocked: boolean;
  onChange: (isLocked: boolean) => void;
  disabled?: boolean;
}

export const LockAspectRatioButton = ({ isLocked, onChange, disabled }: LockAspectRatioButtonProps) => {
  const { t } = useTranslation();
  const toggleLockAspectRatio = () => {
    onChange(!isLocked);
  };

  return (
    <AppToggleButton
      btnH={24}
      btnW={24}
      value={isLocked}
      onChange={toggleLockAspectRatio}
      selected={isLocked}
      disabled={disabled}
      isIcon
      aria-label={t(I18N_KEYS.RECIPE_MAIN.NODES.CROP.LOCK_ASPECT_RATIO)}
      sx={{
        border: 'none',
        [`&.${toggleButtonClasses.selected}`]: {
          border: `1px solid ${color.White08_T}`,
        },
      }}
    >
      {isLocked ? (
        <AspectRatioOnIcon style={{ width: 16, height: 16 }} />
      ) : (
        <AspectRatioIcon style={{ width: 16, height: 16 }} />
      )}
    </AppToggleButton>
  );
};
